import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
import {
  MdDelete,
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { toast } from "react-toastify";
import { RxReload } from "react-icons/rx";
import deleteitem from "../../../components/Images/deleteitem.svg";
import edititem from "../../../components/Images/edititem.svg";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";

function AdsPlan(props) {
  const [dataadscate, setDataadscate] = useState([]);
  const [filteredAdsCategoriesData, setFilteredAdsCategoriesData] = useState([]);
  const [itemToDeleteadscate, setItemToDeleteadscate] = useState([]);
  const [modalCloseadscate, setModalCloseadscate] = useState(false);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [devices, setDevices] = useState([]);

  const access_token = localStorage.getItem("access_token");
  const user_id = localStorage.getItem("user_id");
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const [editUser, setEditUser] = useState({
    user_id: "",
    subscription_plan_name: "",
    subscription_plan_price: "",
    Ads_upload_count_limit: "0",
    Ads_views_count_limit: "0",
    subscription_plan_id: "",
    ios_plan_price: "",
    ios_product_id: "",
    billing_interval: "",
    billing_type: "",
    payment_type: "",
    PaymentGateway_id: "",
    plan_trail_days: "",
    plan_trail_status: "0",
    status: "0",
  });

  const [selectedDevices, setSelectedDevices] = useState({});
  const [postdevices, postDevices] = useState();

  useEffect(() => {
    fetchDataadscate();
    fetchDatanextpreadscate();
  }, [withOutRefresh]);

  const fetchDatanextpreadscate = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/advertisement/plans`,
        { headers: headers }
      );
      const videosData = response?.data?.data;
      setDataadscate(videosData);
      setFilteredAdsCategoriesData(videosData);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching ads plans:", err);
      setLoading(false);
    }
  };

  const fetchDataadscate = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/advertisement/plans-create`,
        { headers: headers }
      );
      setDevices(response?.data?.devices);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: <MdKeyboardDoubleArrowLeft />,
    lastPageText: <MdKeyboardDoubleArrowRight />,
    showTotal: true,
    alwaysShowAllBtns: true,
    sizePerPageList: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "All", value: filteredAdsCategoriesData?.length },
    ],
  });

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (row) {
        const groupPlanId = row?.group_plan_id || row?.id;
        if (isSelect) {
          setItemToDeleteadscate([...itemToDeleteadscate, groupPlanId]);
        } else {
          setItemToDeleteadscate(itemToDeleteadscate.filter((id) => id !== groupPlanId));
        }
      }
    },
    style: { width: '50px' },
    // Map selected group_plan_ids back to actual row ids for checkbox display
    selected: filteredAdsCategoriesData?.filter((row) => {
      const groupPlanId = row?.group_plan_id || row?.id;
      return itemToDeleteadscate.includes(groupPlanId);
    }).map(row => row.id) || [],
    selectionHeaderRenderer: ({ mode, checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const actionFormatter = (data, row) => {
    return (
      <div className="editdropdown">
        <span className="editdropdown-button">
          <span>
            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
          </span>
        </span>
        <div className="editdropdown-menu">
          <Link to={`/preview-ads-subscription-plan/${row?.group_plan_id || row?.id}`}>
            <span>
              <img src={edititem} alt="flogo" width={20} height={20} />
              <span className="ms-2">Edit</span>
            </span>
          </Link>

          <div
            onClick={() => openModalSingleDeleteadscate(row?.group_plan_id || row?.id)}
            className="commonActionPadding"
          >
            <img src={deleteitem} alt="flogo" width={20} height={20} />
            <span className="ms-2"> Delete</span>
          </div>
        </div>
      </div>
    );
  };


  const columns = [
    {
      dataField: "subscription_plan_name",
      text: "Plan Name",
      formatter: (cell, row) => <MessageBox text={cell} classname={"ms-3"} />
    },
    {
      dataField: "subscription_plan_price",
      text: "Plan Amount",
      formatter: (cell, row) => <MessageBox text={cell} classname={"ms-4"} />
    },
    {
      dataField: "Ads_upload_count_limit",
      text: "Ads View Count",
      formatter: (cell, row) => (
        <div className="d-flex align-items-center gap-1 ms-5"><span classname="text-break">{cell}</span></div>
      )
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
    }
  ];

  const handleFilterChangeAdsCategories = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);
    const filteredResults = dataadscate.filter((item) =>
      ["subscription_plan_name", "subscription_plan_price"].some(
        (property) =>
          typeof item[property] === "string" &&
          item[property].toLowerCase().includes(searchTerm)
      )
    );
    setFilteredAdsCategoriesData(filteredResults);
  };

  const handleClear = () => {
    fetchDatanextpreadscate();
    setFilter("");
  };

  const handleAll = () => {
    setSelectAll(!selectAll);
    setItemToDeleteadscate(
      selectAll ? [] : filteredAdsCategoriesData?.map((item) => item?.group_plan_id || item?.id)
    );
  };

  const closeadscateModal = () => {
    setModalCloseadscate(!modalCloseadscate);
    setItemToDeleteadscate([]);
  };

  const openModalSingleDeleteadscate = (id) => {
    setItemToDeleteadscate([id]);
    setModalCloseadscate(true);
  };

  const openModalMultiDeleteadscate = () => {
    setModalCloseadscate(true);
  };

  const handleDeletedata = () => {
    closeadscateModal();
    videosdeleteOperationadscate();
  };

  const videosdeleteOperationadscate = async () => {
    try {
      setLoading(true);
      for (const itemId of itemToDeleteadscate) {
        const response = await axios.delete(
          `${process.env.REACT_APP_Baseurl}/admin/advertisement/plans-delete/${itemId}`,
          { headers: headers }
        );
        const result = response?.data;
        if (result?.status === true) {
          // Enhanced success message with delete count
          const enhancedResult = {
            ...result,
            message: result.deletedCount > 1
              ? `Ads Plan Group deleted successfully! ${result.deletedCount} payment gateway plans removed.`
              : result.message || 'Ads Plan deleted successfully!'
          };
          props.setApiresponsealert(enhancedResult);
          props.setShowalert(true);
          setWithoutRefresh(!withOutRefresh);
        }
      }
      setLoading(false);
    } catch (error) {
      console.error("Error deleting ads plan:", error);
      props.setApiresponsealert({
        status: false,
        message: error?.response?.data?.message || "Failed to delete ads plan",
      });
      props.setShowalert(true);
      setWithoutRefresh(!withOutRefresh);
      setLoading(false);
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));

    setValidationMessagesubscription_plan_name("");
    setIsValidationHiddensubscription_plan_name(true);
    setValidationMessagesubscription_plan_price("");
    setIsValidationHiddensubscription_plan_price(true);
  };

  const handleInputDevices = (deviceId, isChecked) => {
    const updatedDevices = {
      ...selectedDevices,
      [deviceId]: isChecked ? 1 : 0,
    };
    setSelectedDevices(updatedDevices);
    const onDeviceIds = Object.entries(updatedDevices)
      .filter(([_, value]) => value === 1)
      .map(([id]) => Number(id));
    postDevices(onDeviceIds);
  };

  const [validationMessagesubscription_plan_name, setValidationMessagesubscription_plan_name] = useState("");
  const [validationMessagesubscription_plan_price, setValidationMessagesubscription_plan_price] = useState("");
  const [validationMessagesubscription_plan_id, setValidationMessagesubscription_plan_id] = useState("");
  const [validationMessagepostdevices, setValidationMessagepostdevices] = useState("");
  const [isValidationHiddensubscription_plan_name, setIsValidationHiddensubscription_plan_name] = useState(true);
  const [isValidationHiddensubscription_plan_price, setIsValidationHiddensubscription_plan_price] = useState(true);
  const [isValidationHiddensubscription_plan_id, setIsValidationHiddensubscription_plan_id] = useState(true);
  const [isValidationHiddenpostdevices, setIsValidationHiddenpostdevices] = useState(true);

  const subscription_plan_nameInputRef = useRef(null);
  const subscription_plan_priceInputRef = useRef(null);
  const subscription_plan_idInputRef = useRef(null);
  const postdevicesInputRef = useRef(null);

  async function handleUpdate() {
    let focusInputRef = null;

    if (editUser?.subscription_plan_name === "") {
      setValidationMessagesubscription_plan_name("Plan Name cannot be empty.");
      setIsValidationHiddensubscription_plan_name(false);
      focusInputRef = subscription_plan_nameInputRef;
    }
    if (editUser?.subscription_plan_price === "") {
      setValidationMessagesubscription_plan_price("Plan Amount cannot be empty.");
      setIsValidationHiddensubscription_plan_price(false);
      focusInputRef = subscription_plan_priceInputRef;
    }
    if (editUser?.subscription_plan_id === "") {
      setValidationMessagesubscription_plan_id("Plan ID cannot be empty.");
      setIsValidationHiddensubscription_plan_id(false);
      focusInputRef = subscription_plan_idInputRef;
    }
    if (!postdevices || (typeof postdevices === "string" && postdevices.trim() === "")) {
      setValidationMessagepostdevices("Device cannot be empty.");
      setIsValidationHiddenpostdevices(false);
      if (postdevicesInputRef?.current) {
        postdevicesInputRef.current.focus();
      }
      return;
    }

    if (focusInputRef) {
      focusInputRef.current?.focus();
      return;
    }

    const formData = {
      user_id: user_id,
      subscription_plan_name: editUser?.subscription_plan_name,
      subscription_plan_price: editUser?.subscription_plan_price,
      Ads_upload_count_limit: Number(editUser?.Ads_upload_count_limit),
      Ads_views_count_limit: Number(editUser?.Ads_views_count_limit),
      subscription_plan_id: editUser?.subscription_plan_id,
      ios_plan_price: editUser?.ios_plan_price,
      ios_product_id: editUser?.ios_product_id,
      billing_interval: editUser?.billing_interval,
      billing_type: editUser?.billing_type,
      payment_type: editUser?.payment_type,
      PaymentGateway_id: editUser?.PaymentGateway_id,
      plan_trail_days: editUser?.plan_trail_days,
      plan_trail_status: Number(editUser?.plan_trail_status),
      status: Number(editUser?.status),
      devices: postdevices,
    };

    setProcessing(true);
    setShowOverlay(true);

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/advertisement/plans-store`, formData, { headers: headers }
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "Plan updated successfully!");
        setWithoutRefresh(!withOutRefresh);
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Something went wrong while saving the plan.");
        setLoading(false);
      }
    } catch (error) {
      toast.error("An unexpected error occurred.");
      console.error("API Error:", error);
      setLoading(false);
    } finally {
      setProcessing(false);
      setShowOverlay(false);
      setLoading(false);
    }
  }

  const reloadAction = async () => {
    setWithoutRefresh(!withOutRefresh);
  };

  const exportHeaders = [
    { label: "ID", key: "id" },
    { label: "PLAN NAME", key: "subscription_plan_name" },
    { label: "PLAN AMOUNT", key: "subscription_plan_price" },
    { label: "ADS VIEW COUNT", key: "Ads_upload_count_limit" },
  ];

  const generatePDF = async () => {
    const { jsPDF } = await import("jspdf");
    await import("jspdf-autotable");
    const doc = new jsPDF();
    doc.text("ADS PLAN LIST", 10, 10);
    const columns = ["ID", "PLAN NAME", "PLAN AMOUNT", "ADS VIEW COUNT"];
    const data = filteredAdsCategoriesData.map(item => [
      item?.id,
      item?.subscription_plan_name,
      item?.subscription_plan_price,
      item?.Ads_upload_count_limit,
    ]);
    doc.autoTable({ startY: 20, head: [columns], body: data });
    doc.save("ADS-PLAN-LIST.pdf");
  };

  const generateXLSX = async () => {
    const XLSX = await import("xlsx");
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(filteredAdsCategoriesData);
    XLSX.utils.book_append_sheet(wb, ws, "MySheet");
    XLSX.writeFile(wb, "ADS-PLAN-LIST.xlsx");
  };

  return (
    <>
      <div
        className={`modal packageModel ${modalCloseadscate ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: modalCloseadscate ? "block" : "none",
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Deletion</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeadscateModal}
              ></button>
            </div>
            <div className="modal-body">
              {itemToDeleteadscate?.length === 1 ? (
                <div>
                  <p className="fs-6 mb-3">
                    Are you sure you want to delete this Ads Plan Group?
                  </p>
                  <div className="alert alert-warning" role="alert">
                    <strong>⚠️ Warning:</strong> This will delete ALL payment gateway plans. This action cannot be undone.
                  </div>
                </div>
              ) : (
                <div>
                  <p className="fs-6 mb-3">
                    Are you sure you want to delete the selected Ads Plan Groups?
                  </p>
                  <div className="alert alert-warning" role="alert">
                    <strong>⚠️ Warning:</strong> This will delete ALL payment gateway plans in the selected groups. This action cannot be undone.
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={closeadscateModal}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDeletedata}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="exampleModalads" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Create Ads Plan
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
            </div>
            <div className="modal-body">
              <MessageLabel text={"Subscription Plan Name"} className="mandatorySimple" />
              <AdminCustomInput id="subscription_plan_name" type="text" name="subscription_plan_name" value={editUser?.subscription_plan_name} onChange={handleInput} placeHolder={"Enter Plan Name"} ref={subscription_plan_nameInputRef} error={!isValidationHiddensubscription_plan_name ? validationMessagesubscription_plan_name : ""} />

              <MessageLabel text={"Subscription Plan Id"} className="mandatorySimple" />
              <AdminCustomInput id="subscription_plan_id" type="text" name="subscription_plan_id" value={editUser?.subscription_plan_id} onChange={handleInput} placeHolder={"Enter Plan Id"} ref={subscription_plan_idInputRef} error={!isValidationHiddensubscription_plan_id ? validationMessagesubscription_plan_id : ""} />

              <MessageLabel text={"Subscription Plan Amount"} className="mandatorySimple" />
              <AdminCustomInput id="subscription_plan_price" type="number" name="subscription_plan_price" value={editUser?.subscription_plan_price} onChange={handleInput} placeHolder={"Enter Plan Amount"} ref={subscription_plan_priceInputRef} error={!isValidationHiddensubscription_plan_price ? validationMessagesubscription_plan_price : ""} />

              <MessageLabel text={"Ads Upload Count Limit"} />
              <AdminCustomInput id="Ads_upload_count_limit" type="number" name="Ads_upload_count_limit" value={editUser?.Ads_upload_count_limit} onChange={handleInput} placeHolder={"Enter Upload Limit"} />

              <MessageLabel text={"Ads Views Count Limit"} />
              <AdminCustomInput id="Ads_views_count_limit" type="number" name="Ads_views_count_limit" value={editUser?.Ads_views_count_limit} onChange={handleInput} placeHolder={"Enter Views Limit"} />

              <MessageLabel text={"IOS Plan Price"} />
              <AdminCustomInput id="ios_plan_price" type="number" name="ios_plan_price" value={editUser?.ios_plan_price} onChange={handleInput} placeHolder={"Enter iOS Price"} />

              <MessageLabel text={"IOS Product Id"} />
              <AdminCustomInput id="ios_product_id" type="text" name="ios_product_id" value={editUser?.ios_product_id} onChange={handleInput} placeHolder={"Enter Product Id"} />

              <MessageLabel text={"Billing Interval"} />
              <AdminCustomInput id="billing_interval" type="text" name="billing_interval" value={editUser?.billing_interval} onChange={handleInput} placeHolder={"Enter Billing Interval"} />

              <MessageLabel text={"Billing Type"} />
              <AdminCustomInput id="billing_type" type="text" name="billing_type" value={editUser?.billing_type} onChange={handleInput} placeHolder={"Enter Billing Type"} />

              <MessageLabel text={"Payment Type"} />
              <AdminCustomInput id="payment_type" type="text" name="payment_type" cvalue={editUser?.payment_type} onChange={handleInput} placeHolder={"Enter Payment Type"} />

              <MessageLabel text={"Payment Gateway Id"} />
              <AdminCustomInput id="PaymentGateway_id" type="text" name="PaymentGateway_id" value={editUser?.PaymentGateway_id} onChange={handleInput} placeHolder={"Enter Gateway Id"} />

              <MessageLabel text={"Plan Trail Days"} />
              <AdminCustomInput id="plan_trail_days" type="text" name="plan_trail_days" value={editUser?.plan_trail_days} onChange={handleInput} placeHolder={"Enter Trail Days"} />

              <MessageLabel text={"Devices"} className="mb-2 fw-bold" />
              {devices?.map((device, index) => (
                <div key={device?.id} className="d-flex justify-content-between align-items-center mb-2">
                  <span>{device?.devices_name}</span>
                  <AdminSwitch id={`device_${device?.id}`} name={device?.devices_name} checked={selectedDevices[device?.id] === 1} onChange={(e) => handleInputDevices(device?.id, e.target.checked)} ref={index === 0 ? postdevicesInputRef : null} />
                </div>
              ))}
              {!isValidationHiddenpostdevices && (
                <div className="errorred">{validationMessagepostdevices}</div>
              )}

              <div className="d-flex justify-content-between mb-2">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Plan Trail Status"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch
                    id="plan_trail_status"
                    name="plan_trail_status"
                    checked={editUser?.plan_trail_status === 1}
                    onChange={(e) =>
                      handleInput({
                        target: {
                          name: "plan_trail_status",
                          value: e.target.checked ? 1 : 0,
                        },
                      })
                    }
                  />
                </div>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Status"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch
                    id="status"
                    name="status"
                    checked={editUser?.status === 1}
                    onChange={(e) =>
                      handleInput({
                        target: {
                          name: "status",
                          value: e.target.checked ? 1 : 0,
                        },
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-primary ml-3"
                onClick={handleUpdate}
              >
                Update Ads
              </button>
            </div>
          </div>
        </div>
      </div>

      <div>
        {showOverlay && <Response_Processing></Response_Processing>}
      </div>

      <section className="section container-fluid pt-3">
        <div id="content-page" className="content-page">
          <div className="row pb-3 admin-section-title">
            <div className="col-md-8">
              <AdminNavbar heading={"Ads Plan"} totalDataLength={dataadscate?.length} />
            </div>
            <div className="col-md-4 mt-3 mt-md-0" align="right">
              {itemToDeleteadscate?.length > 0 && (
                <button
                  className="btn btn-danger d-inline-flex fw-bolder me-3"
                  onClick={openModalMultiDeleteadscate}
                >
                  <MdDelete className="exportIcon" /> Delete
                </button>
              )}
              <Link
                to="/create-advertisement-plan"
                className="btn btn-primary"
              >
                <i className="fa fa-plus-circle"></i> Add Plan
              </Link>
            </div>
          </div>
          <div className="iq-card mt-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
              <div className="filterContainer">
                <input type="text" placeholder="Search" className="filter form-control" value={filter} onChange={handleFilterChangeAdsCategories} />
                {filter?.length > 0 && (
                  <button type="button" className="closeBtn" onClick={handleClear} >
                    <i className="fa fa-times"></i>
                  </button>
                )}
              </div>
              <div className="d-flex align-items-center">
                <button id="reloadButton" className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2 border border-2 rounded-circle theme-border-color `} onClick={reloadAction} >
                  <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                  <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />

                </button>
                <div className="dropdown d-block ms-2" key={"2"}>
                  <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false" >
                    <span className="fw-bolder text-white">Export All</span>
                    <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                  </button>
                  <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                    <li className="dropdown-item theme-text-color">
                      <CSVLink headers={exportHeaders} data={filteredAdsCategoriesData} className="text-dark d-block" filename="ADS-PLAN-LIST.csv" > CSV </CSVLink>
                    </li>
                    <li className="dropdown-item theme-text-color" onClick={generatePDF} >
                      PDF
                    </li>
                    <li className="dropdown-item theme-text-color" onClick={generateXLSX} >
                      XLSX
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="bootstrapTable">
              <BootstrapTable keyField="id" columns={columns} data={filteredAdsCategoriesData} pagination={pagination} className="no-border-table"
                noDataIndication={
                  <div className="noRecord">
                    {loading ? (
                      <label> <Response_Loading_processing></Response_Loading_processing> Loading... </label>
                    ) : (
                      filteredAdsCategoriesData?.length <= 0 && (<p>No Ads Plans Available!</p>)
                    )}
                  </div>
                }
                hover headerClasses="videoWidth" selectRow={selectRow} selectAll={selectAll}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdsPlan;